<template>
  <div class="full-page-wrap">
    <div class="container">
      <div class="inner-page-wrap slider-upcoming mt-5">
        <carousel :autoplay="true" :loop="true" :items="1" :dots="false">
          <!-- <div class="event-slider">
            <div class="left-img-wrap">
              <img src="../assets/Images/landing/event-slider-img-left.jpg" />
            </div>
            <div class="right-event-slide-wrap">
              <h3>Joint Polytechnic and ITE Food Industry Career Fair 2022</h3>
              <p class="mb-3">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </p>
              <v-btn class="custom-button mr-3">Find Out More</v-btn>
              <v-btn class="register-button">Register Now</v-btn>
            </div>
          </div>

          <div class="event-slider">
            <div class="left-img-wrap">
              <img src="../assets/Images/landing/event-slider-img-left.jpg" />
            </div>
            <div class="right-event-slide-wrap">
              <h3>Joint Polytechnic and ITE Food Industry Career Fair 2022</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </p>
              <v-btn class="custom-button mr-3 mt-sm-2">Find Out More</v-btn>
              <v-btn class="register-button mt-sm-2">Register Now</v-btn>
            </div>
          </div> -->

          <div
            v-for="banner in bannerEvents"
            :key="banner.id"
            class="upcoming-event-banner-hld"
            @click="
              goToBooth(banner.BoothId, banner.BoothName, banner.ExternalLink, 'Banner')
            "
            mouseover
          >
            <a href="javascript:void(0)"
              ><img :src="getCDNUrl(banner.BannerImageUrl)"
            /></a>
          </div>
          <!-- <div  class="upcoming-event-banner-hld">
            <a href="http://dtu-hti.edu.vn/" target="_blank"><img src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FDTU_WYSD_Banner.jpg?alt=media"/></a>
          </div>
          <div class="upcoming-event-banner-hld">
            <a href="https://instagram.com/gcfow2022?igshid=YmMyMTA2M2Y=" target="_blank"><img src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FUPNVY-Event-Banner-Upcoming-Events.jpg?alt=media"/></a>
          </div> -->
        </carousel>

        <div class="event-listing-upcoming pb-12">
          <div
            v-for="singleEvent in upcomingEvents"
            :id="singleEvent.hashtag"
            :key="singleEvent.EventId"
          >
            <div
              v-if="singleEvent.EventShortName && !singleEvent.MonthHeader"
              :class="
                singleEvent.hashtag == currentUrlHash
                  ? 'single-event-tile selected-event'
                  : 'single-event-tile'
              "
            >
              <div class="event-up-logo">
                <div class="event-up-logo-hld">
                  <img
                    v-if="singleEvent.EventLogo"
                    :src="getCDNUrl(singleEvent.EventLogo)"
                  />
                </div>
                <div>
                  <div v-if="singleEvent.EventShortName">
                    <h4>{{ singleEvent.EventShortName }}</h4>
                  </div>
                  <div
                    v-if="singleEvent.EventLocation"
                    v-html="singleEvent.EventLocation"
                  ></div>
                </div>
              </div>
              <div class="upcomin-now-event-desc">
                <div class="event-desc-statement">
                  <h3 v-if="singleEvent.EventFullName">
                    {{ singleEvent.EventFullName }}
                  </h3>
                  <div
                    v-if="singleEvent.Description"
                    v-html="singleEvent.Description"
                  ></div>

                  <p
                    v-if="
                      singleEvent.EventStartDate && singleEvent.EventEndDate
                    "
                    class="date-time-evnt"
                  >
                    {{ singleEvent.EventStartDate }} to
                    {{ singleEvent.EventEndDate }}
                  </p>
                  <p
                    v-else-if="
                      singleEvent.EventStartDate && !singleEvent.EventEndDate
                    "
                    class="date-time-evnt"
                  >
                    {{ singleEvent.EventStartDate }}
                  </p>
                </div>
                <div class="event-enter-butn">
                  <v-btn
                    v-if="
                      (singleEvent.BoothId && singleEvent.BoothName) ||
                      singleEvent.ExternalLink
                    "
                    class="custom-button mb-2 mb-sm-0 mb-xl-2 mb-lg-2 mb-md-0"
                    @click="
                      goToBooth(
                        singleEvent.BoothId,
                        singleEvent.BoothName,
                        singleEvent.ExternalLink,
                        'Find Out More'
                      )
                    "
                    >Find Out More</v-btn
                  >
                  <v-btn
                    v-if="singleEvent.ExternalRegLink"
                    :loading="singleEvent.Registering"
                    :href="singleEvent.ExternalRegLink"
                    target="_blank"
                    class="register-button"
                    width="100%"
                    >Register Now</v-btn
                  >
                  <v-btn
                    v-else
                    :disabled="!singleEvent.RegEnabled"
                    :loading="singleEvent.Registering"
                    @click="
                      Register(
                        singleEvent.BoothId,
                        singleEvent.EventShortName,
                        singleEvent.EventFullName,
                      )
                    "
                    class="register-button"
                    width="100%"
                    >Register Now</v-btn
                  >
                </div>
              </div>
            </div>
            <h3 v-if="singleEvent.MonthHeader" class="common-head text-center">
              {{ singleEvent.MonthHeader }}
            </h3>
          </div>
        </div>
      </div>
    </div>
    <div>
      <PublicFooter></PublicFooter>
    </div>

    <!-- Resgister success dialog -->
    <v-dialog v-model="eventRegSuccessDialog" width="500">
      <v-card>
        <v-card-text>
          <div class="success-event-hld position-rleative">
            <v-btn
              icon
              class="close-btn-success"
              @click="eventRegSuccessDialog = false"
              ><v-icon color="#333" size="24px">mdi-close</v-icon></v-btn
            >
            <img src="../assets/Images/landing/recorded.svg" />
            <p>
              Your interest for the event is successfully recorded. You will
              hear from the Organizer soon.
            </p>
            <v-btn
              dark
              class="yes-submit"
              width="120px"
              @click="eventRegSuccessDialog = false"
              >OK</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import jQuery from "jquery";
let $ = jQuery;
import APIs from "@/components/APIInit";
import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import carousel from "vue-owl-carousel";
import PublicFooter from "@/components/PublicFooter.vue";
import axios from "axios";
import { bus } from "@/main";
import router from "@/router";
import store from "@/store";

Vue.use(VueMoment, {
  moment,
});

var self;
export default {
  components: {
    carousel,
    PublicFooter,
  },
  metaInfo() {
    return {
      title: "World Youth Skills Day (Asia-Pacific) 2022",
      meta: [
        { property: "og:type", content: "website" },
        { name: "description", content: "ASIA-PACIFIC 2022" },
        {
          property: "og:title",
          content: "ASIA-PACIFIC 2022",
        },
        {
          property: "og:url",
          content: location.host,
        },
        { property: "og:type", content: "website" },
        {
          property: "og:description",
          content:
            "The suite of programmes from 15 Jul – 31 October 2022, so that participants know what to expect",
        },
        { property: "og:site_name", content: "Epiloge" },
        {
          property: "og:image",
          content:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FBranding%2F1200x628_1647965462226.png?alt=media&token=098e242f-7301-428b-80da-9afc9cebe25e",
        },
        {
          property: "twitter:card",
          content: "ASIA-PACIFIC 2022",
        },
        {
          property: "twitter:title",
          content: "ASIA-PACIFIC 2022",
        },
        {
          property: "twitter:description",
          content: "ASIA-PACIFIC 2022",
        },
        {
          property: "twitter:url",
          content: location.host,
        },
        {
          property: "twitter:description",
          content: "ASIA-PACIFIC 2022",
        },
        {
          property: "twitter:image",
          content:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FBranding%2F1200x628_1647965462226.png?alt=media&token=098e242f-7301-428b-80da-9afc9cebe25e",
        },
      ],
    };
  },
  data() {
    return {
      eventRegSuccessDialog: false,
      clientId: "",
      bannerEvents: [
        {
          EventId: "1",
          EventShortName: "",
          BannerImageUrl:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FDTU_WYSD_Banner.jpg?alt=media",
          ExternalLink: "http://dtu-hti.edu.vn/",
          IsPublished: true,
          BoothName: "Duy Tan University",
        },

        {
          EventId: "1",
          EventShortName: "",
          BannerImageUrl:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FUPNVY-Event-Banner-Upcoming-Events.jpg?alt=media",
          ExternalLink: "https://instagram.com/gcfow2022?igshid=YmMyMTA2M2Y=",
          IsPublished: true,
          BoothName: "gcfow2022",
        },

        {
          EventId: "1",
          EventShortName: "",
          BannerImageUrl:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FEvent%20Banner-CDTI-min.jpg?alt=media",
          //EventUrl: "https://wysd-apac-2022.e2m.live/exhibitorsview/25971000/Chitralada_Technology_Institute,_Thailand",
          BoothId: "25971000",
          BoothName: "Chitralada Technology Institute, Thailand",
          IsPublished: true,
        },
        {
          EventId: "1",
          EventShortName: "",
          BannerImageUrl:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2FpartnerBanner.jpg?alt=media",
          //EventUrl: "https://wysd-apac-2022.e2m.live/exhibitorsview/25978000/PASSAGE_TO_ASEAN",
          BoothId: "25978000",
          BoothName: "PASSAGE TO ASEAN",
          IsPublished: true,
        },

        {
          EventId: "1",
          EventShortName: "",
          BannerImageUrl:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FSkillsFuture%20Festival-min.png?alt=media",
          //EventUrl: "https://wysd-apac-2022.e2m.live/exhibitorsview/25978000/PASSAGE_TO_ASEAN",
          BoothId: "",
          BoothName: "Skills Future2022",
          ExternalLink: "http://myskillsfuture.gov.sg/SkillsFutureFestival",
          IsPublished: true,
        },
        {
          EventId: "1",
          EventShortName: "",
          BannerImageUrl:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FWorld%20X-min.png?alt=media",
          //EventUrl: "https://wysd-apac-2022.e2m.live/exhibitorsview/25978000/PASSAGE_TO_ASEAN",
          BoothId: "",
          BoothName: "World X",
          ExternalLink: "https://www.hellotac.org/worldx-register",
          IsPublished: true,
        },
        
        {
          EventId: "1",
          EventShortName: "",
          BannerImageUrl:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2Funesco_banner.jpg?alt=media&token=a193f92a-2a2e-4cf9-8dbb-bc9de69de0b1",
          //EventUrl: "https://wysd-apac-2022.e2m.live/exhibitorsview/25978000/PASSAGE_TO_ASEAN",
          BoothId: "",
          BoothName: "",
          ExternalLink: "https://unevoc.unesco.org/home/Skills+in+Action+Photo+Competition+2022",
          IsPublished: true,
        },
        {
          EventId: "1",
          EventShortName: "",
          BannerImageUrl:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2FIdeathon%20Challenge%202022%20-%20WYSD%20Banner_v2-min.png?alt=media&token=d4332290-0c00-405f-907d-487d72d43141",
          //EventUrl: "https://wysd-apac-2022.e2m.live/exhibitorsview/25978000/PASSAGE_TO_ASEAN",
          BoothId: "",
          BoothName: "",
          ExternalLink: "https://wysd-apac-2022.e2m.live/exhibitorsview/26078000/Vocational_Training_Council,_Hong_Kong",
          IsPublished: true,
        },
      ],
      upcomingEvents: [
        {
          MonthHeader: "July 2022",
        },
        {
          EventId: "1",
          hashtag: "Market_Entry_Strategy_to_Indonesia_Summer_Course_2022_July",
          EventShortName: "BINUS University",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1651028588487-logo-binus-university.png?alt=media&token=b3788f3b-6b1e-420c-886b-be1667e0d158",
          EventFullName:
            "Market Entry Strategy to Indonesia Summer Course 2022",
          EventStartDate: "25-Jul-22",
          EventEndDate: "05-Aug-22",
          Description:
            "<p class='mb-2'>This course is an annual program organised by BINUS University to provide the students a unique opportunity to expand their network and gain new experiences. It enables the participants to learn about market entry strategy, Indonesia and its cultures, startups, business ethics, communication decisions, and cross-cultural sales negotiations in a multicultural setting. The participants will also visit both well-established businesses and growing entreprises. </p> <p class='mb-2'>BINUS University is inviting undergraduate students from any countries who are interested in doing business in Indonesia. Through this course, the participants will exchange their knowledge and experience, improve their skills, share insights, and build a friendship</p>",
          Position: 0,
          BoothId: "25970000",
          BoothName: "BINUS University, Indonesia",
          RegEnabled: true,
          Registering: false,
        },
        {
          EventId: "23",
          hashtag: "P2A_Virtual_Entrepreneurship_Hackathon_2022_july",
          EventShortName:
            "Hosted by Passage to ASEAN Association in partnership with P2A member institutions",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2Fp2a.jpg?alt=media",
          EventFullName: "P2A Virtual Entrepreneurship Hackathon 2022",
          EventStartDate: "Jul-2022",
          EventEndDate: "Dec-2022",
          Description:
            "<p>The P2A Virtual Entrepreneurship Hackathon 2022 provides a platform for student participants from P2A Member Institutions to apply their problem-solving skills, showcase their solutions, and explore opportunities to transform their ideas into commercially-viable products/services. Students will present their refined solutions to the given problem statement and are encouraged to commercialise their solutions with the support and incentives received from their respective IHLs. </p>",
          Position: 0,
          BoothId: "25978000",
          BoothName: "PASSAGE TO ASEAN",
          RegEnabled: true,
          Registering: false,
        },

        {
          EventId: "24",
          hashtag: "EUatYourSchool_EU_comes_to_TP",
          EventShortName:
            "Brought to you by: Embassy of the Federal Republic of Germany and Temasek Polytechnic",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FNo_Date_WYSD_Logo.png?alt=media",
          EventFullName: "#EUatYourSchool - EU comes to TP",
          EventStartDate: "21-Jul-2022",
          EventEndDate: "",
          Description:
            "<p class='mb-2'>Ambassador of the Federal Republic of Germany, His Excellency Dr Horbert Riedel will share about Germany-Singapore Relations in the European Union, how both countries cooperate in sustainable development and digitalisation, future potential areas of collaboration, and the essential skills needed by our Youths today. </p> <p>TP students are invited to register and sign up for the keynote session, which will take place physically on 21 July 2022 (10am-12pm) at TP Auditoriam 1.</p>",
          Position: 0,
          BoothId: "",
          BoothName: "",
          ExternalRegLink:"https://form.gov.sg/#!/629712e3d2767d0012e44d1f",
          RegEnabled: true,
          Registering: false,
        },

        {
          EventId: "4",
          hashtag: "Thai_Cuisine_Online_Cooking_Classes",
          EventShortName: "Chitralada Technology Institute, Thailand",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2Fimage_2022_05_03T13_39_08_149Z.png?alt=media&token=56c98e1b-dee0-469c-98ae-dd38f603eb43",
          EventFullName: "Thai Cuisine: Online Cooking Class 1",
          EventStartDate: "5th July",
          EventEndDate: "",
          Description:
            "<p class='mb-2'>The “Online Thai Cooking Classes” is targeted at individuals with interests in food, nutrition and cooking. This is a chance for them to learn about working with Thai cuisines and unique ingredients. Participants will be introduced to use these ingredients properly and may get some idea to adapt some dishes into new fusion cuisine. </p> <p class='mb-2'>“Get Start to join one of these Online Thai Cooking Classes with CDTI, you will never forget how you enjoy cooking.”</p> <p class='mb-0'>Time: Jul 5, 2022 13:30 Bangkok</p> <p class='mb-0'>Join Zoom Meeting: <a href='https://zoom.us/j/94390322041' target='_blank'>https://zoom.us/j/94390322041</a></p> <p>Meeting ID: 943 9032 2041</p>",
          Position: 0,
          BoothId: "25971000",
          BoothName: "Chitralada Technology Institute, Thailand",
          RegEnabled: true,
          Registering: false,
        },
        {
          EventId: "16",
          hashtag: "SZPT_NQC_Tools_and_Practices_Sharing_in_TVET_July",
          EventShortName: "Shenzhen Polytechnic",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FNo_Date_WYSD_Logo.png?alt=media",
          EventFullName: "SZPT NQC Tools and Practices Sharing in TVET",
          EventStartDate: "09-May-22",
          EventEndDate: "31-Dec-22",
          Description:
            "<p class='mb-2'>With a focus on 'New Qualifications and Competencies' (NQC), this programme aims to co-develop and field-test a NQC Self-Reflection Tool (SRT) with UNESCO-UNEVOC. The SRT would be then used to identify, integrate and implement NQC in a timely and accurate manner. </p> <p class='mb-2'>SZPT will design and share the NQC Action Plan, and share promising practices among global TVET peers.</p>",
          Position: 0,
          BoothId: "",
          BoothName: "Shenzhen Polytechnic",
          RegEnabled: false,
          Registering: false,
        },
        {
          EventId: "25",
          hashtag: "Youth_Action_Challenge_Season_3_july",
          EventShortName: "National Youth Council",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FNYC.jpg?alt=media",
          EventFullName: "Youth Action Challenge Season 3",
          EventStartDate: "13-June-22",
          EventEndDate: "29-Jan-22",
          Description:
            "<p class='mb-2'>Organised in partnership with Citi Foundation and the United Nations Development Programme (UNDP) through their Youth Co:Lab initiative, the Youth Action Challenge is a key thrust of the SG Youth Action Plan (SG YAP) which empowers youth to champion ground-up initiatives in partnership with the government, businesses and community organisations, to achieve youth’s vision for Singapore in 2025. The YAC provides the opportunity for youth to turn their ideas into reality through curated workshops and guidance from experienced industry professionals. </p>",
          Position: 0,
          BoothId: "",
          BoothName: "National Youth Council",
          ExternalLink: "https://youthactionplan.sg/YACSeason3/",
          RegEnabled: false,
          Registering: false,
        },
        {
          EventId: "26",
          hashtag: "upcomingevents#World_X",
          EventShortName: "The Astronauts Collective (TAC)",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2FTAC.png?alt=media&token=b1b56439-a3a5-4e39-a787-16b575240332",
          EventFullName: "World X",
          EventStartDate: "16-July-2022",
          EventEndDate: "",
          Description:
            "<p class='mb-2'>World X is a specially-designed career exploration event organised by Lifelong Learning Institute and The Astronauts Collective for youths to explore and discover diverse careers that can contribute towards our world.</p><p class='mb-2'>World X will be held on Sat, 16 July as part of SkillsFuture Festival 2022. Participants can choose to attend the event between 10AM and 4PM on the day, for a recommended duration of 2 - 2.5 hours.</p><p>At the event, students will be able to interact directly with volunteer professionals from a diverse range of jobs and career pathways through experiential activities, networking opportunities, as well as exclusive workshops on practical career preparation skills such as resume writing and interview skills!</p>",
          Position: 0,
          BoothId: "",
          BoothName: "",
          ExternalLink: "https://www.hellotac.org/worldx-register",
          RegEnabled: false,
          Registering: false,
        },
         {
          EventId: "27",
          hashtag: "upcomingevents#SkillsFuture_Festival_2022_july",
          EventShortName: "SkillsFuture Singapore",
          EventLocation: "",
          EventLogo:
            "https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1653301781187-skillsfuturesg_rgb-clear-background.png?alt=media&token=d892c70b-3f49-4098-a484-51680ae30caa",
          EventFullName: "SkillsFuture Festival 2022",
          EventStartDate: "05-July-2022",
          EventEndDate: "14-August-2022",
          Description:
            "<p class='mb-2'>SkillsFuture Festival brings an exciting variety of opportunities for you to discover how you can enhance your skill sets that contribute to employment and employability. With a series of interactive learning events, such as forums, roadshows, workshops and webinars, you will have unparalleled access to a wealth of knowledge from our network of partners.</p><p>Whether you are looking for a job or upgrading your skills to give yourself that competitive edge, SkillsFuture Festival is the perfect opportunity for you to get a head start on your lifelong learning journey. The events also provide easy access to information on how SkillsFuture initiatives and programmes can help you stay relevant in the new economy.<p>",
          Position: 0,
          BoothId: "",
          BoothName: "",
          ExternalLink: "http://www.myskillsfuture.gov.sg/skillsfuturefestival",
          RegEnabled: false,
          Registering: false,
        },
        {
          EventId: "29",
          hashtag: "upcomingevents#Mentoring_SG_july",
          EventShortName: "National Youth Council",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FNYC.jpg?alt=media",
          EventFullName: "Mentoring SG",
          EventStartDate: "July 2022",
          EventEndDate: "December 2022",
          Description:
            "<p class='mb-2'>Mentoring SG is a national movement that aims to build the foundations of a strong mentoring ecosystem. Championed by public-private-people sector stakeholders, we aim to promote a culture of mentoring in Singapore and increase awareness, accessibility and participation in mentoring opportunities.<p><p class='mb-2'>Mentoring is defined as a relationship between a positive and experienced figure and youth, built on mutual trust and respect, providing guidance, support and/ or practical advice to encourage development of competence and character to be a contributing member of society.</p><p>Youths will be able to receive guidance on upskilling of career skills and learning from a mentor who may be from the business industry that they are looking to enter. Mentees will also develop life skills and soft skills that will help them in their growth and personal discovery through various life transitions.</p>",
          Position: 0,
          BoothId: "",
          BoothName: "",
          ExternalLink: "https://mentoring.sg/",
          RegEnabled: false,
          Registering: false,
        },
        {
          MonthHeader: "August 2022",
        },
        {
          EventId: "28",
          hashtag: "upcomingevents#Thai_Cuisine_Online_Cooking_Class_2_Aug",
          EventShortName: "Chitralada Technology Institute, Thailand",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2Fimage_2022_05_03T13_39_08_149Z.png?alt=media&token=56c98e1b-dee0-469c-98ae-dd38f603eb43",
          EventFullName: "Thai Cuisine: Online Cooking Class 2",
          EventStartDate: "9th-Aug-2022",
          EventEndDate: "",
          Description:
            "<p class='mb-2'>The “Online Thai Cooking Classes” is targeted at individuals with interests in food, nutrition and cooking. This is a chance for them to learn about working with Thai cuisines and unique ingredients. Participants will be introduced to use these ingredients properly and may get some idea to adapt some dishes into new fusion cuisine. </p> <p class='mb-2'>“Get Start to join one of these Online Thai Cooking Classes with CDTI, you will never forget how you enjoy cooking.”</p><p class='mb-0'>Menu: Chicken Green Curry & Spicy Mushroom Salad</p><p class='mb-0'>Time: Aug 9, 2022 14:00 - 16:00 BKK</p><p class='mb-0'>Zoom Meeting: <a href='https://zoom.us/j/95339114857'> https://zoom.us/j/95339114857</a></p><p class='mb-0'>Meeting ID: 953 3911 4857<p>",
          Position: 0,
          BoothId: "25971000",
          BoothName: "Chitralada Technology Institute, Thailand",
          RegEnabled: true,
          Registering: false,
        },
        {
          EventId: "5",
          hashtag: "International_Tour_Guide_Competition_Aug",
          EventShortName: "Hospitality & Tourism Institute, Duy Tan University",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FDTU%20logo.png?alt=media",
          EventFullName: "International Tour Guide Competition",
          EventStartDate: "05-Aug-22",
          EventEndDate: "10-Sep-22",
          Description:
            "<p class='mb-2'>This competition aims to inspire youths to re-follow their passion with tour guide career as well as to prepare themselves for the recovery and change of the tourism industry. It hopes to draw youth’s attention to tour guide career as an attractive option for their future job in hospitality & tourism. 2 rounds of the competition will select the best tour guides from institutions around Asia Pacific region for great rewards & prize.</p>",
          Position: 0,
          BoothId: "25978000",
          BoothName: "PASSAGE TO ASEAN",
          RegEnabled: true,
          Registering: false,
        },
        {
          EventId: "6",
          hashtag: "Market_Entry_Strategy_to_Indonesia_Summer_Course_2022_Aug",
          EventShortName: "BINUS University",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1651028588487-logo-binus-university.png?alt=media&token=b3788f3b-6b1e-420c-886b-be1667e0d158",
          EventFullName:
            "Market Entry Strategy to Indonesia Summer Course 2022",
          EventStartDate: "25-Jul-22 ",
          EventEndDate: "05-Aug-22",
          Description:
            "<p class='mb-2'>This course is an annual program organised by BINUS University to provide the students a unique opportunity to expand their network and gain new experiences. The course enables the participants to learn about market entry strategy, Indonesia and its cultures, startups, business ethics, communication decisions, and cross-cultural sales negotiations in a multicultural setting. The participants will also visit both well-established businesses and growing entreprises. </p><p class='mb-2'>BINUS University is inviting undergraduate students from any countries who are interested in doing business in Indonesia. Through this program, the participants will exchange their knowledge and experience, improve their skills, share insights, and build a friendship</p>",
          Position: 0,
          BoothId: "25970000",
          BoothName: "BINUS University, Indonesia",
          RegEnabled: true,
          Registering: false,
        },
        {
          EventId: "7",
          hashtag: "FPT_Education_Global’s_Signature_Program_SDG_Program_2022",
          EventShortName: "FPT Education Global",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FNo_Date_WYSD_Logo.png?alt=media",
          EventFullName:
            "FPT Education Global’s Signature Program: SDG Program 2022",
          EventStartDate: "08-Aug-22 ",
          EventEndDate: "20-Aug-22",
          Description:
            "<p class='mb-2'>FPT Education Global’s Signature Program: SDG Program 2022 is a unique 2-weeks programme for international students to deep-dive in the Sustainability Development Goals. Participants will learn the basics of the Design Thinking approach and will be guided in appplying their skills and knowledge to find solutions to address social challenges. Participants will also get to interact and learn from international peers, creating global relationships and memories.</p><p class='mb-2'>FPT Education Global is inviting undergraduate students who are interested in the UN SDGs to sign up and join this program.</p>",
          Position: 0,
          BoothId: "26047000",
          BoothName: "FPT University",
          RegEnabled: true,
          Registering: false,
        },
        {
          EventId: "8",
          hashtag: "Global_Competence_and_The_Future_of_Work",
          EventShortName:
            "Universitas Pembangunan Nasional “Veteran” Yogyakarta",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FGlobal-competence.jpg?alt=media",
          EventFullName: "Global Competence and The Future of Work",
          EventStartDate: "10-Aug-22",
          EventEndDate: "18-Aug-22",
          Description:
            "<p class='mb-2'>With the aim of increasing awareness and knowledge regarding to global challenges and inter-cultural issues, the Global Competence and The Future of Work provides a digital platform for ASEAN youths to learn, collaborate, and exchange knowledge and ideas on global competencies and the future of work.</p><p class='mb-2'>UPNVY is inviting undergraduate students from any ASEAN countries who are interested to build meaningful networks to address the challenges of the future of work. Participants will develop a posittive and proactive approach to navigating the future employment and skills landscape.</p>",
          Position: 0,
          BoothId: "26049000",
          BoothName: "Universitas Pembangunan Nasional “Veteran” Yogyakarta",
          RegEnabled: true,
          Registering: false,
        },

        {
          EventId: "9",
          hashtag: "International_Community_Development_Program_2022",
          EventShortName: "BINUS University, Indonesia",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1651028588487-logo-binus-university.png?alt=media&token=b3788f3b-6b1e-420c-886b-be1667e0d158",
          EventFullName: "International Community Development Program 2022 ",
          EventStartDate: "21-Aug-22",
          EventEndDate: "27-Aug-22",
          Description:
            "<p class='mb-2'>This programme will provide the students a unique opportunity to expand their network and gain new experiences. Using design thinking, the participants will stay with a local community and see how they can contribute to improve the community’s quality of life.</p><p class='mb-2'>BINUS University is inviting undergraduate students from any countries who are interested in fostering and empowering local community. Through this program, the participants will exchange their knowledge and experience, improve their skills, share insights, and build a friendship.</p>",
          Position: 0,
          BoothId: "25970000",
          BoothName: "BINUS University, Indonesia",
          RegEnabled: true,
          Registering: false,
        },

        {
          EventId: "10",
          hashtag: "SkillsFuture_Work_Study_Fair",
          EventShortName: "Temasek Polytechnic, Singapore",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FNo_Date_WYSD_Logo.png?alt=media",
          EventFullName: "SkillsFuture Work Study Fair",
          EventStartDate: "August",
          EventEndDate: "",
          Description:
            "<p class='mb-2'>The SkillsFuture Work Study Fair will provide opportunities for policy makers and educators in the Asia-Pacific region to better understand how Singapore supports post-secondary education institutions' graduates and mid-career professionals by providing an avenue for them to connect live with industry partners and participating employers for potential career opportunities.</p>",
          Position: 0,
          BoothId: "26003000",
          BoothName: "TSA",
          RegEnabled: true,
          Registering: false,
        },

        {
          EventId: "17",
          hashtag: "SZPT_NQC_Tools_and_Practices_Sharing_in_TVET_Aug",
          EventShortName: "Shenzhen Polytechnic",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FNo_Date_WYSD_Logo.png?alt=media",
          EventFullName: "SZPT NQC Tools and Practices Sharing in TVET",
          EventStartDate: "09-May-22",
          EventEndDate: "31-Dec-22",
          Description:
            "<p class='mb-2'>With a focus on 'New Qualifications and Competencies' (NQC), this programme aims to co-develop and field-test a NQC Self-Reflection Tool (SRT) with UNESCO-UNEVOC. The SRT would be then used to identify, integrate and implement NQC in a timely and accurate manner.</p><p class='mb-2'>SZPT will design and share the NQC Action Plan, and share promising practices among global TVET peers.</p>",
          Position: 0,
          BoothId: "",
          BoothName: "",
          RegEnabled: false,
          Registering: false,
        },
        {
          EventId: "21",
          hashtag:
            "International_Summer_School_and_Hackathon_on_Technology_and_Sustainability_2022",
          EventShortName:
            "King Mongkut’s Institute of Technology Ladkrabang (KMITL)",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2Fking_mongkuts.png?alt=media",
          EventFullName:
            "International Summer School and Hackathon on Technology and Sustainability 2022",
          EventStartDate: "01-Aug-2022",
          EventEndDate: "14-Aug-22",
          Description:
            "<p class='mb-2'>With a focus on Technology and Sustainability, this International Summer School and Hackathon is open to participation by undergraduates around the world and serves as a platform to exchange knowledge and promote innovation.</p><p class='mb-2'>This program provides excellent opportunities for young students to be work together to develop both technical skills and team work skills to across fields of studies and across cultural differences.</p>",
          Position: 0,
          BoothId: "25980000",
          BoothName:
            "King Mongkut's Institute of Technology Ladkrabang (KMITL)",
          RegEnabled: true,
          Registering: false,
        },

        {
          EventId: "22",
          hashtag: "Ideathon_Challenge_Hong_Kong_Japan",
          EventShortName: "Vocational Training Council, Hong Kong",
          EventLocation: "<h4>National Institute of Technology (Kumamoto)</h4>",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FIdeathon%20Challenge%202022%20-%20WYSD%20logo.png?alt=media",
          EventFullName: "Ideathon Challenge Hong Kong–Japan",
          EventStartDate: "25-Aug-2022",
          EventEndDate: "27-Aug-22",
          Description:
            "<p class='mb-2'>The 3-day Ideathon Challenge is an intensive live creative idea contest which gathers students from Hong Kong, Kumamoto and Kitakyushu (Japan) with diverse backgrounds to exchange issues associated with real-life experience and cultures, and create ideas through a virtual platform. Participants would join to collaborate to design and innovate solutions.</p> <p class='mb-2'><b>Day 1 -</b> <b>Thursday 25 Aug 2022</b> 10:30–11:45 (GMT+8) / 11:30–12:45 (GMT+9) Opening & Invited Speech “What’s Smart and what’s Sustainability” by Dr Jun TANIMOTO, Professor, Kyushu University, Japan <a href='https://youtu.be/Kxb_AKbap8g' target='_blank'>https://youtu.be/Kxb_AKbap8g</a></p><p><b>Day 2 -</b> <b>Friday 26 Aug 2022</b> 10:00–10:45 (GMT+8) / 11:00–11:45 (GMT+9) Industry Sharing “Industry’s Practice on Sustainability Innovation” by Ms Serena PAU, Principal Product Lead (Delivery), Digital Services of CLP Innovation Enterprises Limited, Hong Kong <a href='https://youtu.be/5u8wKjqpZNM' target='_blank'>https://youtu.be/5u8wKjqpZNM</a></p>",       
          Position: 0,
          BoothId: "26078000",
          BoothName: "Vocational Training Council, Hong Kong",
          RegEnabled: false,
          Registering: false,
        },
        {
          EventId: "23",
          hashtag: "P2A_Virtual_Entrepreneurship_Hackathon_2022_aug",
          EventShortName:
            "Hosted by Passage to ASEAN Association in partnership with P2A member institutions",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2Fp2a.jpg?alt=media",
          EventFullName: "P2A Virtual Entrepreneurship Hackathon 2022",
          EventStartDate: "Jul-2022",
          EventEndDate: "Dec-2022",
          Description:
            "<p>The P2A Virtual Entrepreneurship Hackathon 2022 provides a platform for student participants from P2A Member Institutions to apply their problem-solving skills, showcase their solutions, and explore opportunities to transform their ideas into commercially-viable products/services. Students will present their refined solutions to the given problem statement and are encouraged to commercialise their solutions with the support and incentives received from their respective IHLs. </p>",
          Position: 0,
          BoothId: "25978000",
          BoothName: "PASSAGE TO ASEAN",
          RegEnabled: true,
          Registering: false,
        },
        {
          EventId: "25",
          hashtag: "Youth_Action_Challenge_Season_3_aug",
          EventShortName: "National Youth Council",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FNYC.jpg?alt=media",
          EventFullName: "Youth Action Challenge Season 3",
          EventStartDate: "13-June-22",
          EventEndDate: "29-Jan-22",
          Description:
            "<p class='mb-2'>Organised in partnership with Citi Foundation and the United Nations Development Programme (UNDP) through their Youth Co:Lab initiative, the Youth Action Challenge is a key thrust of the SG Youth Action Plan (SG YAP) which empowers youth to champion ground-up initiatives in partnership with the government, businesses and community organisations, to achieve youth’s vision for Singapore in 2025. The YAC provides the opportunity for youth to turn their ideas into reality through curated workshops and guidance from experienced industry professionals. </p>",
          Position: 0,
          BoothId: "",
          BoothName: "National Youth Council",
          ExternalLink: "https://youthactionplan.sg/YACSeason3/",
          RegEnabled: false,
          Registering: false,
        },
        {
          EventId: "27",
          hashtag:"upcomingevents#SkillsFuture_Festival_2022_aug",
          EventShortName: "SkillsFuture Singapore",
          EventLocation: "",
          EventLogo:
            "https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1647457916091E1647459328886%2FPartners%2F1653301781187-skillsfuturesg_rgb-clear-background.png?alt=media&token=d892c70b-3f49-4098-a484-51680ae30caa",
          EventFullName: "SkillsFuture Festival 2022",
          EventStartDate: "05-July-2022",
          EventEndDate: "14-August-2022",
          Description:
            "<p class='mb-2'>SkillsFuture Festival brings an exciting variety of opportunities for you to discover how you can enhance your skill sets that contribute to employment and employability. With a series of interactive learning events, such as forums, roadshows, workshops and webinars, you will have unparalleled access to a wealth of knowledge from our network of partners.</p><p>Whether you are looking for a job or upgrading your skills to give yourself that competitive edge, SkillsFuture Festival is the perfect opportunity for you to get a head start on your lifelong learning journey. The events also provide easy access to information on how SkillsFuture initiatives and programmes can help you stay relevant in the new economy.<p>",
          Position: 0,
          BoothId: "",
          BoothName: "",
          ExternalLink: "http://www.myskillsfuture.gov.sg/skillsfuturefestival",
          RegEnabled: false,
          Registering: false,
        },
        {
          EventId: "30",
          hashtag: "upcomingevents#Mentoring_SG_aug",
          EventShortName: "National Youth Council",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FNYC.jpg?alt=media",
          EventFullName: "Social Entrepreneurship Programme",
          EventStartDate: "03-Aug-2022",
          EventEndDate: "23-Sept.-2022",
          Description:
            "<p class='mb-2'>The Social Entrepreneurship Programme (SEC) is a youth exchange programme that will equip you with the “know-hows” into social entrepreneurship while helping you to uncover your strengths and sharpen your emotional intelligence in a work environment. You will also gain cross-cultural and practical  skills to better compete in the global markets.<p><p class='mb-2'>The SEC comprises of two tracks: Youth track for 18 years old & below, and Adult track for 19 years old & above. You will get to work in cross-cultural teams (comprising of peers from ASEAN countries, China and India) on a business proposal based on the United Nation’s Sustainable Development Goals, with the guidance of an industry mentor. You will also get to attend a series of workshops on design thinking for social impact (Youth track) or startup leadership (Adult track), and webinars on the cultural and economic landscapes of China.</p>",
          Position: 0,
          BoothId: "",
          BoothName: "",
          ExternalLink: "http://go.gov.sg/aepcatalogue",
          RegEnabled: false,
          Registering: false,
        },
        {
          EventId: "31",
          hashtag: "upcomingevents#Social_Entrepreneurship_Programme_aug",
          EventShortName: "National Youth Council",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FNYC.jpg?alt=media",
          EventFullName: "Mentoring SG",
          EventStartDate: "July-2022",
          EventEndDate: "December-2022",
          Description:
            "<p class='mb-2'>Mentoring SG is a national movement that aims to build the foundations of a strong mentoring ecosystem. Championed by public-private-people sector stakeholders, we aim to promote a culture of mentoring in Singapore and increase awareness, accessibility and participation in mentoring opportunities.</p><p class='mb-2'>Mentoring is defined as a relationship between a positive and experienced figure and youth, built on mutual trust and respect, providing guidance, support and/ or practical advice to encourage development of competence and character to be a contributing member of society.</p><p>Youths will be able to receive guidance on upskilling of career skills and learning from a mentor who may be from the business industry that they are looking to enter. Mentees will also develop life skills and soft skills that will help them in their growth and personal discovery through various life transitions.</p>",
          Position: 0,
          BoothId: "",
          BoothName: "",
          ExternalLink: "https://mentoring.sg/",
          RegEnabled: false,
          Registering: false,
        },
        {
          EventId: "35",
          hashtag: "Future_Innovations_and_Essential_Mandatory_Life_Skills",
          EventShortName: "Rangsit University",
          EventLocation: "<h4>&nbsp;</h4>",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2FRangsit_University-removebg-preview.png?alt=media&token=6e86d753-8766-44d7-aa84-d6a47dbb8ee5",
          EventFullName: "Future Innovations and Essential Mandatory Life Skills",
          EventStartDate: "22-Aug-2022 ",
          EventEndDate: "26-Aug-2022",
          Description:
            "<p class='mb-2'><b>[Exclusive to Participating Institutions only] </b></p><p class='mb-2'>In this programme, students from 4 participating IHLs namely, Rangsit University (Thailand), FPT University (Vietnam), Wesleyan University and Tarlac Agricultural University (Philippines) will participate in a series of lectures on future-ready skills and group discussions. At the end of the programme, students will present their views on the impact of innovative and health technology on the world via Infographic, Video Clip or Mind-Map.</p>",
          Position: 0,
          BoothId: "",
          BoothName: "",
          RegEnabled: false,
          Registering: false,
        },
        {
          EventId: "36",
          hashtag: "UNESCO_UNEVOC_Skills_in_Action_Photo_Competition",
          EventShortName: "UNESCO-UNEVOC International Centre for Technical and Vocational Education and Training",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2FUnesco.jpg?alt=media&token=684bc835-6931-4a09-90a3-884fdb82bb8a",
          EventFullName: "UNESCO-UNEVOC Skills in Action Photo Competition",
          EventStartDate: "01-Aug-2022 ",
          EventEndDate: "31-Aug-2022",
          Description:
            "<p class='mb-2'>Are you an amateur or professional photographer with an interest in youth skills? Don’t miss your chance to take part in the UNESCO-UNEVOC Skills in Action Photo Competition!</p><p class='mb-2'>Photos should show green and digital skills in Technical and Vocational Education and Training (TVET). We want to see how TVET is preparing young people with green and digital skills for the future. This year's theme is Transforming Youth Skills for the Future and submissions should focus on TVET for a sustainable future and Preparing for a digital world.</p><p class='mb-2'>The winners of the Skills in Action Photo Competition 2022 will receive the following prizes:1st Prize - 750 USD , 2nd Prize - 500 USD, 3rd Prize - 350 USD</p>",
          Position: 0,
          BoothId: "",
          BoothName: "",
          ExternalLink: "https://unevoc.unesco.org/home/Skills+in+Action+Photo+Competition+2022",
          RegEnabled: false,
          Registering: false,
        },
        {
          MonthHeader: "September 2022",
        },
        {
          EventId: "11",
          hashtag:
            "Student_e-Xchange_Programme_Re-designing_TVET_for_the_Future",
          EventShortName: "Temasek Polytechnic, Singapore",
          EventLocation:
            "<h4>Multimedia University, Malaysia</h4><h4>Rangsit University, Thailand</h4>",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FStudent%20E-Xchange%20Prog%20photos-July-Sep-Oct.jpg?alt=media&token=b133224c-5e0a-4d57-bdca-030cda48e809",
          EventFullName:
            "Student e-Xchange Programme: Re-designing TVET for the Future",
          EventStartDate: "06-Sep-2022",
          EventEndDate: "30-Sep-22",
          Description:
            "<p class='mb-2'><strong>[Exclusive to Participating Institutions only]</strong></p><p>In this e-exchange programme, students from 3 participating IHLs (TP, Multimedia University and Rangsit University) will be given a scenario/statement and must then explore solutions in re-designing TVET for the future. Students, in their mixed IHL groups, will then get to present their findings in TikTok video clips at the end of the programme.</p>",
          Position: 0,
          BoothId: "",
          BoothName: "",
          RegEnabled: false,
          Registering: false,
        },
        {
          EventId: "18",
          hashtag: "Thematic_Dialogue_Re-designing_TVET_for_the_Future",
          EventShortName: "Temasek Polytechnic, Singapore",
          EventLocation:
            "<h4>Multimedia University, Malaysia</h4><h4>Rangsit University, Thailand</h4>",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FThematic%20Dialogue%20photos-July-Sep-Oct.jpg?alt=media&token=62a21402-d900-441d-b751-940ebc671b0a",
          EventFullName: "Thematic Dialogue: Re-designing TVET for the Future",
          EventStartDate: "06-Sep-2022",
          EventEndDate: "",
          Description:
            "<p class='mb-2'>As part of the WYSD (APAC) Student e-Xchange and Thematic Dialogue series, we invite youths from the region to join us in this personal and interactive discussion centred on 'Re-designing TVET for the Future'.</p><p><strong>[Part 1 - Thematic Dialogue: Open to Public]</strong> Thematic Dialogue: Re-designing TVET for the Future invites distinguished speakers – practitioner or academia staff and students from Singapore, Malaysia and Thailand to speak from their experience and/or share their vision of TVET for the future. </p>",
          Position: 0,
          BoothId: "",
          BoothName: "",
          RegEnabled: false,
          Registering: false,
        },
        {
          EventId: "12",
          hashtag: "International_Tour_Guide_Competition_Sep",
          EventShortName: "Hospitality & Tourism Institute, Duy Tan University",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FDTU%20logo.png?alt=media",
          EventFullName: "International Tour Guide Competition",
          EventStartDate: "05-Aug-22",
          EventEndDate: "10-Sep-22",
          Description:
            "<p class='mb-2'>This competition aims to inspire youths to re-follow their passion with tour guide career as well as to prepare themselves for the recovery and change of the tourism industry. It hopes to draw youth’s attention to tour guide career as an attractive option for their future job in hospitality & tourism. 2 rounds of the competition will select the best tour guides from institutions around Asia Pacific region for great rewards & prize.</p>",
          Position: 0,
          BoothId: "25978000",
          BoothName: "PASSAGE TO ASEAN",
          RegEnabled: true,
          Registering: false,
        },

        {
          EventId: "13",
          hashtag:
            "International_Symposium_on_Advances_in_Technology_Education_(ISATE)",
          EventShortName: "ISATE 2022",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FResources%2FISATE-2022.jpg?alt=media",
          EventFullName:
            "15th International Symposium on Advances in Technology Education (ISATE)",
          EventStartDate: "20-Sep-22",
          EventEndDate: "23-Sep-22",
          Description:
            "<p class='mb-2'>Technical education and training are central to the achievement of youth employment, decent work, digitalisation, entrepreneurship and lifelong learning. It can also tackle the changing skill-demands by companies and economies. In this fast changing world, this conference provides a platform for educators to discuss and share insights in the innovation and future developments of Technical Education.</p><p class='mb-2'>Organised by: National Institute of Technology (KOSEN), Japan, Nagaoka University of Technology, Japan, Toyohashi University of Technology, Japan, the five Singapore polytechnics (Singapore Polytechnic, Ngee Ann Polytechnic, Temasek Polytechnic, Nanyang Polytechnic and Republic Polytechnic), Vocational Training Council, Hong Kong and Turku University of Applied Sciences, Finland.</p>",
          Position: 0,
          BoothId: "",
          BoothName: "",
          RegEnabled: true,
          Registering: false,
        },
        {
          EventId: "19",
          hashtag: "SZPT_NQC_Tools_and_Practices_Sharing_in_TVET_Sep",
          EventShortName: "Shenzhen Polytechnic",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FNo_Date_WYSD_Logo.png?alt=media",
          EventFullName: "SZPT NQC Tools and Practices Sharing in TVET",
          EventStartDate: "09-May-22",
          EventEndDate: "31-Dec-22",
          Description:
            "<p class='mb-2'>With a focus on 'New Qualifications and Competencies' (NQC), this programme aims to co-develop and field-test a NQC Self-Reflection Tool (SRT) with UNESCO-UNEVOC. The SRT would be then used to identify, integrate and implement NQC in a timely and accurate manner.</p><p class='mb-2'>SZPT will design and share the NQC Action Plan, and share promising practices among global TVET peers.</p>",
          Position: 0,
          BoothId: "",
          BoothName: "",
          RegEnabled: false,
          Registering: false,
        },
        {
          EventId: "23",
          hashtag: "P2A_Virtual_Entrepreneurship_Hackathon_2022_sep",
          EventShortName:
            "Hosted by Passage to ASEAN Association in partnership with P2A member institutions",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2Fp2a.jpg?alt=media",
          EventFullName: "P2A Virtual Entrepreneurship Hackathon 2022",
          EventStartDate: "Jul-2022",
          EventEndDate: "Dec-2022",
          Description:
            "<p>The P2A Virtual Entrepreneurship Hackathon 2022 provides a platform for student participants from P2A Member Institutions to apply their problem-solving skills, showcase their solutions, and explore opportunities to transform their ideas into commercially-viable products/services. Students will present their refined solutions to the given problem statement and are encouraged to commercialise their solutions with the support and incentives received from their respective IHLs. </p>",
          Position: 0,
          BoothId: "25978000",
          BoothName: "PASSAGE TO ASEAN",
          RegEnabled: true,
          Registering: false,
        },
        {
          EventId: "25",
          hashtag: "Youth_Action_Challenge_Season_3_sep",
          EventShortName: "National Youth Council",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FNYC.jpg?alt=media",
          EventFullName: "Youth Action Challenge Season 3",
          EventStartDate: "13-June-22",
          EventEndDate: "29-Jan-22",
          Description:
            "<p class='mb-2'>Organised in partnership with Citi Foundation and the United Nations Development Programme (UNDP) through their Youth Co:Lab initiative, the Youth Action Challenge is a key thrust of the SG Youth Action Plan (SG YAP) which empowers youth to champion ground-up initiatives in partnership with the government, businesses and community organisations, to achieve youth’s vision for Singapore in 2025. The YAC provides the opportunity for youth to turn their ideas into reality through curated workshops and guidance from experienced industry professionals. </p>",
          Position: 0,
          BoothId: "",
          BoothName: "National Youth Council",
          ExternalLink: "https://youthactionplan.sg/YACSeason3/",
          RegEnabled: false,
          Registering: false,
        },
        {
          EventId: "32",
          hashtag: "upcomingevents#Mentoring_SG_sep",
          EventShortName: "National Youth Council",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FNYC.jpg?alt=media",
          EventFullName: "Social Entrepreneurship Programme",
          EventStartDate: "03-Aug-2022",
          EventEndDate: "23-Sept.-2022",
          Description:
            "<p class='mb-2'>The Social Entrepreneurship Programme (SEC) is a youth exchange programme that will equip you with the “know-hows” into social entrepreneurship while helping you to uncover your strengths and sharpen your emotional intelligence in a work environment. You will also gain cross-cultural and practical  skills to better compete in the global markets.<p><p class='mb-2'>The SEC comprises of two tracks: Youth track for 18 years old & below, and Adult track for 19 years old & above. You will get to work in cross-cultural teams (comprising of peers from ASEAN countries, China and India) on a business proposal based on the United Nation’s Sustainable Development Goals, with the guidance of an industry mentor. You will also get to attend a series of workshops on design thinking for social impact (Youth track) or startup leadership (Adult track), and webinars on the cultural and economic landscapes of China.</p>",
          Position: 0,
          BoothId: "",
          BoothName: "",
          ExternalLink: "http://go.gov.sg/aepcatalogue",
          RegEnabled: false,
          Registering: false,
        },
        {
          EventId: "33",
          hashtag: "upcomingevents#Social_Entrepreneurship_Programme_sep",
          EventShortName: "National Youth Council",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FNYC.jpg?alt=media",
          EventFullName: "Mentoring SG",
          EventStartDate: "July-2022",
          EventEndDate: "December-2022",
          Description:
            "<p class='mb-2'>Mentoring SG is a national movement that aims to build the foundations of a strong mentoring ecosystem. Championed by public-private-people sector stakeholders, we aim to promote a culture of mentoring in Singapore and increase awareness, accessibility and participation in mentoring opportunities.</p><p class='mb-2'>Mentoring is defined as a relationship between a positive and experienced figure and youth, built on mutual trust and respect, providing guidance, support and/ or practical advice to encourage development of competence and character to be a contributing member of society.</p><p>Youths will be able to receive guidance on upskilling of career skills and learning from a mentor who may be from the business industry that they are looking to enter. Mentees will also develop life skills and soft skills that will help them in their growth and personal discovery through various life transitions.</p>",
          Position: 0,
          BoothId: "",
          BoothName: "",
          ExternalLink: "https://mentoring.sg/",
          RegEnabled: false,
          Registering: false,
        },
        {
          EventId: "37",
          hashtag: "upcomingevents#Social_Entrepreneurship_Programme_sep",
          EventShortName: "Virtual Cultural Museum",
          EventLocation: "<h4>Temasek Polytechnic</h4>",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FStudent%20E-Xchange%20Prog%20photos-July-Sep-Oct.jpg?alt=media&token=b133224c-5e0a-4d57-bdca-030cda48e809",
          EventFullName: "Virtual Cultural Museum",
          EventStartDate: "17-Sep-22",
          EventEndDate: "",
          Description:
            "<p class='mb-2'>TP invites you to join the Virtual Cultural Museum – a cultural event organised by 9 Co-Curricular Activities and Interest Groups from TP:  International Students Group, Global Connect Student Group, Japanese Cultural Group, Malay Dance Group, Indian Dance Group, Chinese Orchestra, TP Emcees, Toastmasters, and Visual Arts and Writing Club.</p><p class='mb-2'>Students and youths will learn about the different cultures in several countries, by listening to speeches about diversity and watching stellar cultural music and art performances.</p><p class='mb-2'><p>Time: 9am-12pm SGT<br/>Venue - Livestream from YouTube</p>",
          Position: 0,
          BoothId: "",
          BoothName: "",
          ExternalLink: "https://docs.google.com/forms/d/e/1FAIpQLSfVIfz3t4EODo0chRNpZRVehAISz-abtP5EKxFn8vAv7pKKow/viewform",
          RegEnabled: false,
          Registering: false,
        },
        {
          MonthHeader: "October 2022",
        },

        {
          EventId: "14",
          hashtag: "Student_e-Xchange_Programme_Waste_Management",
          EventShortName: "Temasek Polytechnic, Singapore",
          EventLocation:
            " <h4>Kumamoto NIT, Japan</h4> <h4>King Mongkut's Institute of Technology Ladkrabang, Thailand</h4>",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FStudent%20E-Xchange%20Prog%20photos-July-Sep-Oct.jpg?alt=media&token=b133224c-5e0a-4d57-bdca-030cda48e809",
          EventFullName: "Student e-Xchange Programme: Waste Management",
          EventStartDate: "04-Oct-22",
          EventEndDate: "31-Oct-22",
          Description:
            "<p class='mb-2'><strong>[Exclusive to Participating Institutions only] </strong></p><p class='mb-2'>In this e-exchange programme, students from 3 Temasek Polytechnic, Kumamoto NIT and King Mongkut's Institute of Technology Ladkraban will identify a problem statement related to Waste Management and explore solutions to address the problem statement. Students will then get to present their solutions via TikTok videos at the end of the e-exchange programme and for them to share their views on future-ready skills in the green economy.</p>",
          Position: 0,
          BoothId: "",
          BoothName: "",
          RegEnabled: false,
          Registering: false,
        },

        {
          EventId: "15",
          hashtag: "Thematic_Dialogue_Waste_Management",
          EventShortName: "Temasek Polytechnic, Singapore",
          EventLocation:
            " <h4>Kumamoto NIT, Japan</h4> <h4>King Mongkut's Institute of Technology Ladkrabang, Thailand</h4>",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FThematic%20Dialogue%20photos-July-Sep-Oct.jpg?alt=media&token=62a21402-d900-441d-b751-940ebc671b0a",
          EventFullName: "Thematic Dialogue: Waste Management",
          EventStartDate: "04-Oct-22",
          EventEndDate: "",
          Description:
            "<p class='mb-2'>As part of the WYSD (APAC) Student e-Xchange and Thematic Dialogue series, we invite youths from the region to join us in the personal and interactive discussion centred on 'Waste Management', which includes discussion on E-Waste Management, Food Waste Management, Reducing Waste and Sustainable Consumption. </p><p class='mb-2'>'Thematic Dialogue: Waste Management' invites distinguished speakers from Singapore, Japan and Thailand to showcase their best practices in Waste Management and thereby building liveable cities in the digital and green economy. What does this mean for youths moving forward?</p>",
          Position: 0,
          BoothId: "",
          BoothName: "",
          RegEnabled: false,
          Registering: false,
        },
        {
          EventId: "20",
          hashtag: "SZPT_NQC_Tools_and_Practices_Sharing_in_TVET_Oct",
          EventShortName: "Shenzhen Polytechnic",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FNo_Date_WYSD_Logo.png?alt=media",
          EventFullName: "SZPT NQC Tools and Practices Sharing in TVET",
          EventStartDate: "09-May-22",
          EventEndDate: "31-Dec-22",
          Description:
            "<p class='mb-2'>With a focus on 'New Qualifications and Competencies' (NQC), this programme aims to co-develop and field-test a NQC Self-Reflection Tool (SRT) with UNESCO-UNEVOC. The SRT would be then used to identify, integrate and implement NQC in a timely and accurate manner.</p><p>SZPT will design and share the NQC Action Plan, and share promising practices among global TVET peers.</p>",
          Position: 0,
          BoothId: "",
          BoothName: "",
          RegEnabled: false,
          Registering: false,
        },
        {
          EventId: "23",
          hashtag: "P2A_Virtual_Entrepreneurship_Hackathon_2022_oct",
          EventShortName:
            "Hosted by Passage to ASEAN Association in partnership with P2A member institutions",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2Fp2a.jpg?alt=media",
          EventFullName: "P2A Virtual Entrepreneurship Hackathon 2022",
          EventStartDate: "Jul-2022",
          EventEndDate: "Dec-2022",
          Description:
            "<p>The P2A Virtual Entrepreneurship Hackathon 2022 provides a platform for student participants from P2A Member Institutions to apply their problem-solving skills, showcase their solutions, and explore opportunities to transform their ideas into commercially-viable products/services. Students will present their refined solutions to the given problem statement and are encouraged to commercialise their solutions with the support and incentives received from their respective IHLs. </p>",
          Position: 0,
          BoothId: "25978000",
          BoothName: "PASSAGE TO ASEAN",
          RegEnabled: true,
          Registering: false,
        },
        {
          EventId: "25",
          hashtag: "Youth_Action_Challenge_Season_3_oct",
          EventShortName: "National Youth Council",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FNYC.jpg?alt=media",
          EventFullName: "Youth Action Challenge Season 3",
          EventStartDate: "13-June-22",
          EventEndDate: "29-Jan-22",
          Description:
            "<p class='mb-2'>Organised in partnership with Citi Foundation and the United Nations Development Programme (UNDP) through their Youth Co:Lab initiative, the Youth Action Challenge is a key thrust of the SG Youth Action Plan (SG YAP) which empowers youth to champion ground-up initiatives in partnership with the government, businesses and community organisations, to achieve youth’s vision for Singapore in 2025. The YAC provides the opportunity for youth to turn their ideas into reality through curated workshops and guidance from experienced industry professionals. </p>",
          Position: 0,
          BoothId: "",
          ExternalLink: "https://youthactionplan.sg/YACSeason3/",
          BoothName: "National Youth Council",
          RegEnabled: false,
          Registering: false,
        },
        {
          EventId: "34",
          hashtag: "upcomingevents#Mentoring_SG_oct",
          EventShortName: "National Youth Council",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FNYC.jpg?alt=media",
          EventFullName: "Mentoring SG",
          EventStartDate: "July-2022",
          EventEndDate: "December-2022",
          Description:
            "<p class='mb-2'>Mentoring SG is a national movement that aims to build the foundations of a strong mentoring ecosystem. Championed by public-private-people sector stakeholders, we aim to promote a culture of mentoring in Singapore and increase awareness, accessibility and participation in mentoring opportunities.</p><p class='mb-2'>Mentoring is defined as a relationship between a positive and experienced figure and youth, built on mutual trust and respect, providing guidance, support and/ or practical advice to encourage development of competence and character to be a contributing member of society.</p><p>Youths will be able to receive guidance on upskilling of career skills and learning from a mentor who may be from the business industry that they are looking to enter. Mentees will also develop life skills and soft skills that will help them in their growth and personal discovery through various life transitions.</p>",
          Position: 0,
          BoothId: "",
          BoothName: "",
          ExternalLink: "https://mentoring.sg/",
          RegEnabled: false,
          Registering: false,
        },
        {
          EventId: "38",
          hashtag: "Towards_a_Green_Inclusive_&_Digital_Future_Video_Campaign_Oct",
          EventShortName: "Hannah Emilia & Lina Farhanah (Temasek Polytechnic)",
          EventLocation: "",
          EventLogo:
            "https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1647457916091E1647459328886%2FStudent%20E-Xchange%20Prog%20photos-July-Sep-Oct.jpg?alt=media&token=b133224c-5e0a-4d57-bdca-030cda48e809",
          EventFullName: "‘Towards a Green, Inclusive & Digital Future’ Video Campaign",
          EventStartDate: "10-Oct-2022",
          EventEndDate: "30-October-2022",
          Description:
            "<p class='mb-2'>This campaign aims to create awareness among students of the makeshift in the future of work - the Green and Digital transition in the world of work. We will be sharing information on this makeshift via social media platforms (i.e., Instagram). Additionally, the organisers would like to introduce to the audience the core skills needed for their future career. Following the information sharing, the organisers will be conducting interviews to understand students’ perspectives on skills relevancy and competency for the future of work. In this way, the programme aim to inspire other youth alike to equip themselves for working life.</p><p class='mb-2'>Our target outreach for this initiative are youths from Temasek Polytechnic, as well as fellow Youth Ambassadors from other countries. They may do so by submitting a self-recorded video answering the interview questions in no more than 10 minutes.</p><p>Regiser here: <a href='https://forms.gle/j3GwsPJQarr7PgibA' target='_blank'>https://forms.gle/j3GwsPJQarr7PgibA</a></p>",
          Position: 0,
          BoothId: "",
          BoothName: "",
          ExternalLink: "https://www.instagram.com/ascstudiesclub/",
          RegEnabled: false,
          Registering: false,
        },
        {
          EventId: "39",
          hashtag: "Entrepreneurship_for_a_Green_Future_International_Youth_Forum_Oct",
          EventShortName: "Zhejiang Technical Institute of Economics",
          EventLocation: "",
          EventLogo:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT_C1647457916091E1647459328886%2FExhibitor%2FResources%2FZJTIE.jpg?alt=media&token=25c8d3be-ed3f-40c4-819d-641003570885",
          EventFullName: "'Entrepreneurship for a Green Future' International Youth Forum",
          EventStartDate: "10-Oct-2022",
          EventEndDate: "",
          Description:
            "<p class='mb-2'>This forum focuses on entrepreneurship and green development. It aims to raise participants’ awareness of innovation and entrepreneurship, and create an opportunity for them to share their opinions towards SDGs, TVET, youth development and other related topics with youths from a variety of countries, as well as to help participants develop their skills of business planning, innovation and communication, which are important to employment, decent work and entrepreneurship.</p><p class='mb-2'>ZJTIE welcomes all interested youths to participate in the forum via the link below.</p><p>Date & Time: 10 October 2022, 0830 - 1130am (GMT +8)<br/>Forum Link: <a href='https://meeting.tencent.com/dm/MmEbkHvjR5TC' target='_blank'>https://meeting.tencent.com/dm/MmEbkHvjR5TC</a></p>",
          Position: 0,
          BoothId: "",
          BoothName: "",
          ExternalLink: "https://meeting.tencent.com/dm/MmEbkHvjR5TC",
          RegEnabled: false,
          Registering: false,
        },
      ],
      currentUrlHash: "",
    };
  },
  computed: {},
  watch: {},
  created() {
    self = this;
    self.clientId = self.getClientId();
    self.publicEventCollection = self.getPublicEventCollection();
    self.event_collectionName = self.getEventCollectionName();
  },
  mounted() {
    var data = {
      showUserWelcomeLoader: false,
    };
    if (location.hash) {
      self.currentUrlHash = location.hash.replace("#", "");
    }
    bus.$emit("setUserWelcomeLoader", data);
    document.title = "Upcoming Events";
    //self.getEventBanners();
    //self.getUpcomingEvents();
    self.scrollToBottom(this.$route.hash);
  },
  methods: {
    scrollToBottom(id) {
      if (id) {
        $("html,body").animate(
          {
            scrollTop: $(id).offset().top - 190,
          },
          "500"
        );
      }
    },
    getEventBanners() {
      self.bannerEvents = self.bannerEvents.filter(function (item) {
        item.BannerImageUrl = self.getCDNUrl(item.BannerImageUrl);
        return item.IsPublished;
      });
    },
    getUpcomingEvents() {
      self.upcomingEvents = self.upcomingEvents.filter(function (item) {
        if (item.EventLogo) {
          item.EventLogo = self.getCDNUrl(item.EventLogo);
        }
        return true;
      });
    },
    eventRegSuccess() {
      self.eventRegSuccessDialog = true;
    },
    goToBooth(boothId, boothName, ExternalLink, option) {
      var user = self.getSessionUserProfile();
      var _boothName = boothName;
      if (boothName) {
        boothName = boothName.replace(/ /g, "_");
      }
      var eventFound = false;
      if (user && user.UserId) {
        if (
          self.event_collectionName &&
          self.event_collectionName == self.publicEventCollection
        ) {
          eventFound = true;
          self.AddEventAnalytics({ pageName: "/upcomingevents", action: "click", actionType: "", actionLabel: option + ": " + _boothName });
          if (ExternalLink) {
            window.open(ExternalLink, "_blank");
          } else {
            router.push("/exhibitorsview/" + boothId + "/" + boothName);
          }
          return;
        } else {
          var mappedEvents = self.GetMappedEvents();
          for (var i = 0; i < mappedEvents.length; i++) {
            if (
              self.publicEventCollection == mappedEvents[i].EventCollectionName
            ) {
              //self.CurrentAdminEvent = mappedEvents[i];
              self.ChangeCurrentEvent(
                mappedEvents[i].ClientId,
                mappedEvents[i].EventId,
                false,
                true
              );
              setTimeout(() => {
                self.AddEventAnalytics({ pageName: "/upcomingevents", action: "click", actionType: "", actionLabel: option + ": " + _boothName });
                if (ExternalLink) {
                  window.open(ExternalLink, "_blank");
                } else {
                  router.push("/exhibitorsview/" + boothId + "/" + boothName);
                }
              }, 1000);

              eventFound = true;
              break;
            }
          }
        }
      }
      if (!eventFound) {
        let eventId = self.getPublicEventId();
        if (ExternalLink) {
          window.open(ExternalLink, "_blank");
        } else {
          store.commit(
            "setUrlReq",
            "/exhibitorsview/" + boothId + "/" + boothName
          );
          router.push(
            "/?visitor-login=true&event_id=" +
              eventId +
              "&redirect_url=/exhibitorsview/" +
              boothId +
              "/" +
              boothName
          );
          //self.goToVisitorLogin();
        }
      }
    },

    Register(boothId, EventShortName, EventFullName) {
      self.refreshRegisterProgress(boothId, true);
      var user = self.getSessionUserProfile();
      if (user && user.UserId && user.Email != "visitor@e2m.live") {
        let headers = {
          "Content-Type": "application/json",
        };
        var requestData = {};
        requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: self.clientId,
          },
          PrimaryData: {
            //UserId: user.UserId,
            FirstName: user.FirstName,
            LastName: user.LastName,
            Email: user.Email,
            Phone: user.Phone,
            Company: user.Company,
            Designation: user.Designation,
            ProfileImageURL: user.ProfileImageURL,
            "Event Short Name": EventShortName,
            "Event Full Name": EventFullName,
          },
          MetaData: {},
        };
        axios
          .post(APIs.AddToSpreadsheet, requestData, { headers: headers })
          .then(function (res) {
            self.refreshRegisterProgress(boothId, false);
            if (res.data.status == 0) {
              self.eventRegSuccessDialog = true;
            }
          })
          .catch(() => {
            self.refreshRegisterProgress(boothId, false);
          });
        self.AddEventAnalytics({ pageName: "/upcomingevents", action: "click", actionType: "", actionLabel: "Register Now: " + EventShortName });
      } else {
        self.refreshRegisterProgress(boothId, false);
        let eventId = self.getPublicEventId();
        router.push("/?&event_id=" + eventId + "&redirect_url=/upcomingevents");
      }
    },
    refreshRegisterProgress(boothId, status) {
      for (let i = 0; i < self.upcomingEvents.length; i++) {
        if (self.upcomingEvents[i].BoothId == boothId) {
          self.upcomingEvents[i].Registering = status;
          break;
        }
      }
      // self.upcomingEvents = self.upcomingEvents.filter(function () {
      //   return true;
      // });
    },
  },
};
</script>